import { ModelType, ModelTypeDisplayNames } from "./ModelTypes";

export enum ModelGroup {
    BinaryClassification = "BinaryClassification",
    MulticlassClassification = "MulticlassClassification",
    Regression = "Regression",
    Clustering = "Clustering",
    NeuralNetwork = "NeuralNetwork",
    Other = "Other"
}

export const ModelGroupDisplayNames: Record<ModelGroup, string> = {
    [ModelGroup.BinaryClassification]: "Binary Classification",
    [ModelGroup.MulticlassClassification]: "Multiclass Classification",
    [ModelGroup.Regression]: "Regression",
    [ModelGroup.Clustering]: "Clustering",
    [ModelGroup.NeuralNetwork]: "Neural Networks",
    [ModelGroup.Other]: "Other"
};

export type ModelGroupItem = {
    groupType: ModelGroup;
    displayName: string;
    modelTypes: ModelGroupTypeItem[];
}

export type ModelGroupTypeItem = {
    label: string;
    modelType: ModelType;
}

export const getModelGroupTypeItem = (type: ModelType): ModelGroupTypeItem => {
    return {
        label: ModelTypeDisplayNames[type],
        modelType: type
    };
}

export const getGroupedModelTypes = (): ModelGroupItem[] => [
    {
        groupType: ModelGroup.BinaryClassification,
        displayName: ModelGroupDisplayNames[ModelGroup.BinaryClassification],
        modelTypes: [
            getModelGroupTypeItem(ModelType.AveragedPerceptron),
            getModelGroupTypeItem(ModelType.SdcaNonCalibrated),
            getModelGroupTypeItem(ModelType.SgdNonCalibrated),
            getModelGroupTypeItem(ModelType.LinearSvm),
            getModelGroupTypeItem(ModelType.LbfgsLogisticRegression),
            getModelGroupTypeItem(ModelType.RandomForest)
        ]
    },
    {
        groupType: ModelGroup.MulticlassClassification,
        displayName: ModelGroupDisplayNames[ModelGroup.MulticlassClassification],
        modelTypes: [
            getModelGroupTypeItem(ModelType.LightGbm),
            getModelGroupTypeItem(ModelType.SdcaMaximumEntropy),
            getModelGroupTypeItem(ModelType.OneVersusAll),
            getModelGroupTypeItem(ModelType.PairwiseCoupling),
            getModelGroupTypeItem(ModelType.LbfgsMaximumEntropy),
            getModelGroupTypeItem(ModelType.NaiveBayes)
        ]
    },
    {
        groupType: ModelGroup.Regression,
        displayName: ModelGroupDisplayNames[ModelGroup.Regression],
        modelTypes: [
            getModelGroupTypeItem(ModelType.LightGbmRegression),
            getModelGroupTypeItem(ModelType.RandomForestRegression),
            getModelGroupTypeItem(ModelType.SdcaRegression),
            getModelGroupTypeItem(ModelType.LbfgsPoissonRegression),
            getModelGroupTypeItem(ModelType.OnlineGradientDescent)
        ]
    },
    {
        groupType: ModelGroup.Clustering,
        displayName: ModelGroupDisplayNames[ModelGroup.Clustering],
        modelTypes: [
            getModelGroupTypeItem(ModelType.KMeans),
        ]
    },
    {
        groupType: ModelGroup.NeuralNetwork,
        displayName: ModelGroupDisplayNames[ModelGroup.NeuralNetwork],
        modelTypes: [
            getModelGroupTypeItem(ModelType.NeuralNetwork)
        ]
    },
    {
        groupType: ModelGroup.Other,
        displayName: ModelGroupDisplayNames[ModelGroup.Other],
        modelTypes: [getModelGroupTypeItem(ModelType.Onnx)]
    }
]
